const Detail = (): React.JSX.Element => {
   return (
      <details className="note introduction" style={{ marginTop: '0.2em', marginBottom: '1em' }}>
         <summary>Introduction</summary>
         <p>
            <b>AHoJ</b> is a structural bioinformatics tool that allows automated
            <b>search</b> and <b>alignment</b> of <b>APO</b> structures for a given
            <b>HOLO</b> structure (and vice versa) in the PDB.
            <br />
            <b>It can be used to create customized Apo-Holo datasets.</b>
         </p>
         <p>
            AHoJ is an application for finding structures that belong to the same protein with a user-specified query
            structure, and annotating them as apo or holo. It can be used for making a single search and
            visualizing/downloading the results, or serialized by entering multiple queries to generate a dataset of
            structures. The user starts the search by providing their ligand of interest - or its binding site) and
            setting the preferred parameters.
         </p>
         <h4>How it works?</h4>
         <img
            src="flow_chart.svg"
            alt="Flowchart: How it works?"
            style={{ marginTop: '0em', marginBottom: '0em', zIndex: -1 }}
         />
         <h4>Quick description</h4>
         It features multiple modes of search, but its main functionality is ligand-centric, meaning that the user
         specifies a particular binding site (by entering a binding residue) - or a ligand directly - and AHoJ will find
         the same binding site in the other structures (by superimposing the two at a time) and interogate it for
         ligands.
         <h5>Specifying the ligand or the binding site</h5>
         <p>
            This is done by providing the i)structure, ii)chain, iii)name of ligand or residue (using the PDB
            3-character code) and iv)position of ligand or residue in the sequence (PDB residue index is used).
            Specifying all these four arguments is recommended as it avoids ambiguity in the case that more than one
            ligand molecules of the same type exist within the same chain. When specifying a residue, it is obligatory
            to specify the position. However, the minimum number of arguments is one - structure. In such case, AHoJ
            will try to automatically detect chains, ligands and their positions. It can work with ligands that are
            designated as heteroatoms in the PDB, which means small and medium-sized ligands but not protein subunits.
         </p>
         <p>
            Therefore, the main and default search is starting with a holo structure, where the user knows the ligand
            that will be used as a starting point. This user-specified ligand will then define the search and annotation
            of the results. Any other ligands in the query structure will not play a role in characterising results as
            apo or holo. In the case that the user does not know the ligand or the binding site, AHoJ can automatically
            detect available ligands in the query structures if told to do so. If the query structure however does not
            bind any ligands (apo), the user can still use the "reverse search" mode, where AHoJ will look for
            structures that belong to the same protein with the query, but it will not focus on a particular binding
            site. Instead it will list any ligand that it detects in the resulting chains.
         </p>
      </details>
   );
};

export default Detail;
